import { FC, SVGAttributes } from 'react';

import TextBalloon from '@/assets/icons/TextBalloon';

import styles from './Notitie.module.css';

const NotitieIcon: FC<SVGAttributes<SVGSVGElement>> = ({ ...iconProps }) => {
  return <TextBalloon width='24px' height='24px' className={styles.notitieIconStyle} {...iconProps} />;
};
export default NotitieIcon;
